import React, { useState } from "react";
import { AccordionContainer } from "../../../../common/components/accordion/accordion.module";
import { InputContainer } from "../../../../common/components/form/input/containers/input.container";

export default function GlobalDbnBluePrintRegistriesLegTemplate({
    selectedCategory, MovementPattern, HaulClass,
    handleInnerLegTemplateChange, addLegTemplate, deleteLegTemplate, legTemplates, LegType
}: any) {

    return (
        <>
            <AccordionContainer
                headerTitle={`Leg Templates (${legTemplates.length})`}
                expandedPanel="userInfo"
                child={
                    <div className="space-y-5">
                        {legTemplates.map((item, index) => (
                            <div
                                key={item.id}
                                className="border rounded-xl p-5 bg-white shadow-sm"
                            >
                                <div className="flex justify-between items-center mb-4">
                                    <h3 className="font-semibold text-gray-700">
                                        #{index + 1}
                                    </h3>

                                    <button
                                        type="button"
                                        onClick={() => deleteLegTemplate(index)}
                                        className="text-red-500 text-sm"
                                    >
                                        Delete
                                    </button>
                                </div>

                                <div className="grid md:grid-cols-3 gap-4">
                                    {/* Leg Origin */}
                                    <div className="text-black">
                                        <InputContainer
                                            label="Leg Origin"
                                            labelField="Text"
                                            list={LegType}
                                            isDisabled={!!selectedCategory?.GlobalBluePrintRegistryId}
                                            type="select"
                                            optionName="Select Leg Origin"
                                            value={item.legType}
                                            valueField="Value"
                                            onValueChange={(event: any) => {
                                                handleInnerLegTemplateChange(
                                                    Number(event.target.value),
                                                    "legType",
                                                    index
                                                );
                                            }}
                                        />
                                    </div>

                                    {/* Movement Pattern */}
                                    <div className="text-black">
                                        <InputContainer
                                            label="Movement Pattern"
                                            labelField="Text"
                                            list={MovementPattern}
                                            isDisabled={!!selectedCategory?.GlobalBluePrintRegistryId}
                                            type="select"
                                            optionName="Select Movement Pattern"
                                            value={item.movementPattern}
                                            valueField="Value"
                                            onValueChange={(event: any) => {
                                                handleInnerLegTemplateChange(
                                                    Number(event.target.value),
                                                    "movementPattern",
                                                    index
                                                );
                                            }}
                                        />
                                    </div>

                                    {/* Haul Class */}
                                    <div className="text-black">
                                        <InputContainer
                                            label="Haul Class"
                                            labelField="Text"
                                            list={HaulClass}
                                            isDisabled={!!selectedCategory?.GlobalBluePrintRegistryId}
                                            type="select"
                                            optionName="Select Haul Class"
                                            value={item.haulClass}
                                            valueField="Value"
                                            onValueChange={(event: any) => {
                                                handleInnerLegTemplateChange(
                                                    Number(event.target.value),
                                                    "haulClass",
                                                    index
                                                );
                                            }}
                                        />
                                    </div>

                                    {/* Label */}
                                    <InputContainer
                                        label="Label"
                                        type="text"
                                        isDisabled={!!selectedCategory?.GlobalBluePrintRegistryId}
                                        value={item.label}
                                        onValueChange={(e: any) =>
                                            handleInnerLegTemplateChange(
                                                e.target.value,
                                                "label",
                                                index
                                            )
                                        }
                                    />

                                    {/* Est Hours Min */}
                                    <InputContainer
                                        label="Est. Hours Min"
                                        type="text"
                                        value={item.estHoursMin}
                                        isDisabled={!!selectedCategory?.GlobalBluePrintRegistryId}
                                        onValueChange={(e: any) =>
                                            handleInnerLegTemplateChange(
                                                e.target.value,
                                                "estHoursMin",
                                                index
                                            )
                                        }
                                    />

                                    {/* Est Hours Max */}
                                    <InputContainer
                                        label="Est. Hours Max"
                                        type="text"
                                        value={item.estHoursMax}
                                        isDisabled={!!selectedCategory?.GlobalBluePrintRegistryId}
                                        onValueChange={(e: any) =>
                                            handleInnerLegTemplateChange(
                                                e.target.value,
                                                "estHoursMax",
                                                index
                                            )
                                        }
                                    />
                                </div>
                            </div>
                        ))}

                        {/* Add Button */}
                        <button
                            type="button"
                            onClick={addLegTemplate}
                            className="w-full border-2 border-dashed rounded-xl py-4 text-blue-600 font-medium"
                        >
                            + Add Leg Template
                        </button>
                    </div>
                }
            />
        </>
    );
}